var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9950_143527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9950_143527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload_2",
    d: "M7.66671 10.3845V4.61787L6.11286 6.17172L5.64106 5.69224L8.00004 3.33325L10.359 5.69224L9.88722 6.17172L8.33337 4.61787V10.3845H7.66671ZM4.41029 12.6666C4.10346 12.6666 3.84726 12.5638 3.64171 12.3583C3.43615 12.1527 3.33337 11.8965 3.33337 11.5897V9.97429H4.00004V11.5897C4.00004 11.6922 4.04277 11.7862 4.12824 11.8717C4.21372 11.9572 4.30773 11.9999 4.41029 11.9999H11.5898C11.6923 11.9999 11.7864 11.9572 11.8718 11.8717C11.9573 11.7862 12 11.6922 12 11.5897V9.97429H12.6667V11.5897C12.6667 11.8965 12.5639 12.1527 12.3584 12.3583C12.1528 12.5638 11.8966 12.6666 11.5898 12.6666H4.41029Z",
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLight);
export default __webpack_public_path__ + "static/media/uploadLight.9b58572d1f5de660f4a75dee61622b44.svg";
export { ForwardRef as ReactComponent };